module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "inventorycontainer",
    staticClass: "inventory-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-input', {
    staticStyle: {
      "float": "right",
      "width": "300px"
    },
    attrs: {
      "placeholder": "快速搜索",
      "clearable": ""
    },
    on: {
      "change": _vm.searchList
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.searchList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.vagueContent),
      callback: function($$v) {
        _vm.vagueContent = $$v
      },
      expression: "vagueContent"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "300px",
      "margin-right": "20px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择禁用、启用状态"
    },
    on: {
      "change": _vm.classFilter
    },
    model: {
      value: (_vm.inventoryStatus),
      callback: function($$v) {
        _vm.inventoryStatus = $$v
      },
      expression: "inventoryStatus"
    }
  }, _vm._l((_vm.inventoryStatusOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "300px",
      "margin-right": "20px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择商品分类"
    },
    on: {
      "change": _vm.classFilter
    },
    model: {
      value: (_vm.sortCode),
      callback: function($$v) {
        _vm.sortCode = $$v
      },
      expression: "sortCode"
    }
  }, _vm._l((_vm.allClassDatas), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.syncCommodity
    }
  }, [_vm._v("同步商品")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 85,
      "highlight-current-row": "",
      "id": "out-table",
      "border": ""
    }
  }, [_c('af-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(((!!_vm.pageNum && !!_vm.pageSize) ? ((_vm.pageNum - 1) * _vm.pageSize) : 0) + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "code",
      "label": "  商品编号  ",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "sortCode",
      "label": "商品分类",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "图片",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!!scope.row.thumimage),
            expression: "!!scope.row.thumimage"
          }],
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.thumimage,
            "fit": "cover"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "ccomunitname",
      "label": "单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "refsaleprice",
      "label": "零售价",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "150",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status === 0 ? '禁用' : '启用'))]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "pageSize": _vm.pageSize,
      "pageNum": _vm.pageNum,
      "totalNum": _vm.totalNum
    },
    on: {
      "handlePageSizeChange": _vm.handlePageSizeChange,
      "handlePageCurrentChange": _vm.handlePageCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品名称",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "id": "focus-ele",
      "disabled": _vm.codeDisabled
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品编号",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.codeDisabled
    },
    model: {
      value: (_vm.formData.code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "code", $$v)
      },
      expression: "formData.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片",
      "prop": ""
    }
  }, [_c('UploadFile', {
    ref: "UploadFile",
    attrs: {
      "imgUrl": _vm.formData.thumimage
    },
    on: {
      "getFileUrl": _vm.getFileUrl
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-387da0de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/inventoryManagement/Inventory.vue
// module id = 702
// module chunks = 1